import React from "react"
import { TableBody, TableRow, TableRowColumn } from "material-ui/Table"

import * as types from "components/person/types"


const colStyle = {
    wordWrap: "break-word",
    whiteSpace: "normal"
}

export default props => {
    const data = []
    let i = 0

    props.data.forEach(rating => {
        data.push(
            <TableRow
                key={ rating.get("id") }
                selected={ props.selectedRow === i++ }
                style={{
                    color: (rating.get("user_created") === "admin" ? "#09c": "")
                }}>
                <TableRowColumn
                    style={ colStyle }
                    title={ rating.get("rating") }>
                    { rating.get("rating") }
                </TableRowColumn>
                <TableRowColumn
                    style={ colStyle }>
                    { rating.get("rank") }
                </TableRowColumn>
                { props.type !== types.FLIGHT_ATTENDANT ?
                    <TableRowColumn
                        style={ colStyle }>
                        { rating.get("hours") }
                    </TableRowColumn>
                    : null
                }
                { props.type !== types.FLIGHT_ATTENDANT ?
                    <TableRowColumn
                        style={ colStyle }>
                        { (rating.get("valid") !== null) ?
                            rating.get("valid")
                            : ""
                        }
                    </TableRowColumn>
                    : null
                }
                { props.type !== types.ENGINEER ?
                    <TableRowColumn
                        style={ colStyle }
                        title={ rating.get("rate") }>
                        { rating.get("rate") }
                    </TableRowColumn>
                    : null
                }
            </TableRow>
        )
    })

    return <TableBody showRowHover={ true }>{ data }</TableBody>
}


/** WEBPACK FOOTER **
 ** ./src/components/person/Ratings/table-body.js
 **/